//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Neonatal_shock_scale",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        value5: "",
      },
  
      hasScore: false,
      disabled: false,
      dataList1: [
        {
          value: "0",
          name: "正常",
        },
        {
          value: "1",
          name: " 凉至膝、肘以下或肛-指温差6~8℃",
        },
        {
          value: "2",
          name: "凉至膝、肘以上或肛-指温差≥9℃",
        },
      ],
      dataList2: [
        {
          value: "0",
          name: "正常",
        },
        {
          value: "1",
          name: " 弱",
        },
        {
          value: "2",
          name: "未触及",
        },
      ],
      dataList3: [
        {
          value: "0",
          name: "＞8.0kPa（60mmHg）",
        },
        {
          value: "1",
          name: "6.0~8.0kPa（46~60mmHg）",
        },
        {
          value: "2",
          name: "＜6.0kPa（45mmHg）",
        },
      ],
      dataList4: [
        {
          value: "0",
          name: "正常",
        },
        {
          value: "1",
          name: "苍白",
        },
        {
          value: "2",
          name: "花纹",
        },
      ],
      dataList5: [
        {
          value: "0",
          name: "＜3秒",
        },
        {
          value: "1",
          name: "3~4秒",
        },
        {
          value: "2",
          name: "＞4秒",
        },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == "---") {
              flag = false;
            } else {
              form[key] = Number(form[key]);
            }
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "--";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/Neonatal_shock_scale.vue